<template>
    <div class="alm-timeline-wrapper">
        <AlmTimelineComponent v-for="tenant in currentChangeset?.detail" :key="tenant?.id" :currentTenant="tenant" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AlmTimelineComponent from "@/components/pages/landscape/AlmTimelineComponent.vue";

export default defineComponent({
    components: {
        AlmTimelineComponent,
    },
    props: {
        currentChangeset: Object,
    },
});
</script>

<style scoped>
.alm-timeline-wrapper {
    display: flex;
    flex-direction: column; 
    gap: 16px; 
}
</style>
